"use strict";

exports.__esModule = true;
exports["default"] = withTranslate;
exports.withTranslateProps = void 0;

var _lodash = require("lodash");

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _urijs = _interopRequireDefault(require("urijs"));

var _createHocName = _interopRequireDefault(require("../services/create-hoc-name"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NAME = 'WithTranslate';
var showKeys = typeof window !== 'undefined' && (0, _urijs["default"])(window.location).hasQuery('debug-translate', 'true');
var withTranslateProps = ['i18n', 'lng', 't', 'tReady'];
exports.withTranslateProps = withTranslateProps;

function withTranslate(WrappedComponent) {
  var WithTranslate = /*#__PURE__*/function (_Component) {
    _inheritsLoose(WithTranslate, _Component);

    function WithTranslate() {
      return _Component.apply(this, arguments) || this;
    }

    var _proto = WithTranslate.prototype;

    _proto.render = function render() {
      var props = (0, _lodash.omit)(this.props, ['i18nLoadedAt']);

      if (showKeys) {
        props.t = function (key) {
          return key;
        };
      }

      return /*#__PURE__*/_react["default"].createElement(WrappedComponent, props);
    };

    return WithTranslate;
  }(_react.Component);

  _defineProperty(WithTranslate, "displayName", (0, _createHocName["default"])(NAME, WrappedComponent));

  (0, _hoistNonReactStatics["default"])(WithTranslate, WrappedComponent);
  return (0, _reactI18next.translate)(['translation'])(WithTranslate);
}